<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1100"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          <div>
            <div>Printer Status - {{aligner.serialNumber}}</div>
            <div style="font-size: 12px; font-weight: normal"><i>{{decodedSerialNumber}}</i></div>
            <div v-if="aligner && aligner.status" style="font-size: 12px; font-weight: normal">Report created at: {{aligner.createdAt}}</div>
          </div>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="onCloseClick()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <v-card flat style="overflow-y: auto; height: 300px; background-color: #F5F5F5;">
              <div v-if="aligner && aligner.status">
                <div
                  v-for="(line, index) in lines"
                  :index="index"
                  :key="index"
                  :ticket="line"
                >
                  {{line}}
                </div>
              </div>
              <div
                v-if="aligner && aligner.status === null"
                class="pa-3"
                style="background-color: black; color: white; text-align: center;"
              >
                NO REPORT
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="blue" text @click="onCloseClick()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import decodeSerialNumber from '../../decodeSerialNumber';

export default {
  components: {
  },

  props: {
    dialog: Boolean,
    aligner: Object,
  },

  computed: {
    decodedSerialNumber() {
      if (this.aligner.serialNumber) {
        const decodedSerialNumber = decodeSerialNumber(this.aligner.serialNumber.toUpperCase());
        if (decodedSerialNumber) {
          return `${decodedSerialNumber.marketingName} ${decodedSerialNumber.buildMonth}/${decodedSerialNumber.buildYear}`;
        }
      }

      return '...';
    },

    lines() {
      if (this.aligner.status) {
        return this.aligner.status.split('\n');
      }

      return [];
    },
  },

  methods: {
    onRefreshClick() {
      this.$emit('refresh');
    },

    onCloseClick() {
      this.$emit('close');
    },
  },
};
</script>
